import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import { withStyles } from '@material-ui/core/styles';
import { CardTitle } from 'material-ui/Card';
import 'react-input-range/lib/css/index.css';
import { daysDiff, getDatesRange, getInputRangeLabels, getInputRangeInit, dateToIso, getUtcStringWithoutHours } from './helpers';
import activitySave from './../../../data/linearCalendar/actions';
import { httpStatus } from './../../../data/constants';
import { DefaultButton } from '../../Buttons';
import { useLanguage } from '../../../context/LanguageContext';
import './styles.scss';

const CancelButton = withStyles({
  root: {
    backgroundColor: '#009688',
    borderColor: '#009688',
    color: 'white',
  },
})(DefaultButton);

const SaveApplyButton = withStyles({
  root: {
    backgroundColor: '#009688',
    borderColor: '#009688',
    color: 'white',
  },
})(DefaultButton);

class VacationAdder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      disabled: false,
      vacationStart: null,
      vacationEnd: null,
      vactionwidth: 850,
      dayswidth: 0,
      totalvacationdays: [],
      vacation: [],
      vactionadddays: [],
      vactionnoadddays: []
    };

    this.handleClose = props.handleClose;

    this.activityId = props.activityId;
    this.vacationWindowStart = props.validatedVacationSlideStartDate;
    this.vacationWindowEnd = props.validatedVacationSlideEndDate;
    this.originalVacationStart = props.originalStartDate;
    this.originalVacationEnd = props.originalEndDate;
    this.vacationStart = getUtcStringWithoutHours(props.startDate);
    this.vacationEnd = getUtcStringWithoutHours(props.endDate);

    this.bidSessionStartDate = new Date(getUtcStringWithoutHours(new Date(
      props.bidSessionStartDate[0],
      props.bidSessionStartDate[1] - 1,
      props.bidSessionStartDate[2]
    ))).getTime();

    this.datesRange = getDatesRange(this.vacationWindowStart, this.vacationWindowEnd);
    this.inputRangeMin = 0;
    this.inputRangeMax = this.datesRange.length - 1;
    this.inputRangeLabels = getInputRangeLabels(this.datesRange);
    this.inputRangePreviousSelection = {};
    this.inputRangeInit = getInputRangeInit(this.vacationStart, this.vacationEnd, this.datesRange);
    this.maxVacationDays = daysDiff(this.originalVacationStart, this.originalVacationEnd);

    this.state.value = this.inputRangeInit;
    this.state.vacationStart = this.vacationStart;
    this.state.vacationEnd = this.vacationEnd;

    if (this.vacationStart === this.vacationEnd) {
      this.vacationStart = getUtcStringWithoutHours(this.originalVacationStart);
      this.vacationEnd = getUtcStringWithoutHours(this.originalVacationEnd);
      this.inputRangeInit = getInputRangeInit(
        this.vacationStart,
        this.vacationEnd,
        this.datesRange);

      this.state = {
        value: 0,
        disabled: true,
        vacationStart: null,
        vacationEnd: null,
      };
    }
  }
  componentDidMount() {
    this.range();
  }

  range = () => {
    const startdate = dateToIso(this.vacationStart).split('-');
    const startday = parseFloat(startdate[2]);
    const startdays = startday - 3;
    const enddate = dateToIso(this.vacationEnd, true).split('-');
    const endday = parseFloat(enddate[2]);
    const enddays = endday + 3;
    const result = Array(enddays - startdays + 1).fill().map((_, idx) => startdays + idx);
    const vactionresult = Array(endday - startday + 1).fill().map((_, idx) => startday + idx);
    this.setState({
      vaction: vactionresult,
      vactionadddays: result.filter(el => vactionresult.indexOf(el) === -1),
      dayswidth: 85
    }, () => {
      this.vactiondays();
    });
  }
  vactiondays = () => {
    const totaldays = [];

    this.state.vaction.map((item) => {
      totaldays.push({
        value: item,
        color: '#008000'
      });
    });
    this.state.vactionadddays.map((value) => {
      totaldays.push({
        value,
        color: '#FFFF00'
      });
    });
    this.state.vactionnoadddays.map((value) => {
      totaldays.push({
        value,
        color: '#808080'
      });
    });
    this.setState({
      totalvacationdays: totaldays.sort((a, b) => a.value - b.value)
    });
  }
  handleClick = (date, color) => {
    const startdate = dateToIso(this.vacationStart).split('-');
    const startday = parseFloat(startdate[2]);
    const enddate = dateToIso(this.vacationEnd, true).split('-');
    const endday = parseFloat(enddate[2]);
    let vaction = [...this.state.vaction];
    let vactionadddays = [...this.state.vactionadddays];
    const vactionnoadddays = [...this.state.vactionnoadddays];
    if (color !== '#808080') {
      if (date < startday) {
        const result = Array((startday - 1) - date + 1).fill().map((_, idx) => date + idx);
        const found = vaction.find(element => element === date);
        if (found) {
          const data = vaction.filter(item => item <= date);
          vaction = [...new Set(vaction.filter(item => item > date))];
          data.map((items) => {
            vactionadddays.push(items);
          });
          var i;
          for (i = 0; i < data.length; i++) {
            vactionadddays.push(vactionnoadddays.pop());
          }

          this.setState({
            vaction: [...new Set(vaction)],
            vactionadddays: [...new Set(vactionadddays.filter(item => item !== undefined))],
            vactionnoadddays: [...new Set(vactionnoadddays.filter(item => item !== undefined))],
          }, () => {
            this.vactiondays();
          });
          const dates = vaction.sort((a, b) => a - b);
          this.setState({

            vacationStart: getUtcStringWithoutHours(new Date(
              this.props.bidSessionStartDate[0],
              this.props.bidSessionStartDate[1] - 1,
              dates[0] + 1
            ).getTime())
          });
        } else {
          result.map((items) => {
            vaction.push(items);
          });
          const vactionadddaysfilter = [...new Set(vactionadddays.filter(item => result.includes(item)))];
          vactionadddays = [...new Set(vactionadddays.filter(item => !result.includes(item)))];
          var i;
          for (i = 0; i < vactionadddaysfilter.length; i++) {
            vactionnoadddays.push(vactionadddays.pop());
          }
          this.setState({
            vaction: [...new Set(vaction)],
            vactionadddays: [...new Set(vactionadddays.filter(item => item !== undefined))],
            vactionnoadddays: [...new Set(vactionnoadddays.filter(item => item !== undefined))],
          }, () => {
            this.vactiondays();
          });
          const dates = vaction.sort((a, b) => a - b);

          this.setState({
            vacationStart: getUtcStringWithoutHours(new Date(
              this.props.bidSessionStartDate[0],
              this.props.bidSessionStartDate[1] - 1,
              dates[0] + 1
            ).getTime())
          });
        }
      } else if (date > endday) {
        const results = Array(date - (endday + 1) + 1).fill().map((_, idx) => (endday + 1) + idx);
        const found = vaction.find(element => element === date);
        if (found) {
          const data = vaction.filter(item => item >= date);

          vaction = [...new Set(vaction.filter(item => item < date))];
          data.map((items) => {
            vactionadddays.push(items);
          });
          var i;
          for (i = 0; i < data.length; i++) {
            vactionadddays.push(vactionnoadddays.pop());
          }

          this.setState({
            vaction: [...new Set(vaction)],
            vactionadddays: [...new Set(vactionadddays.filter(item => item !== undefined))],
            vactionnoadddays: [...new Set(vactionnoadddays.filter(item => item !== undefined))],
          }, () => {
            this.vactiondays();
          });
          const dates = vaction.sort((a, b) => b - a);

          this.setState({
            vacationEnd: getUtcStringWithoutHours(new Date(
              this.props.bidSessionStartDate[0],
              this.props.bidSessionStartDate[1] - 1,
              dates[0] + 2
            ).getTime())
          });
        } else {
          vactionadddays = vactionadddays.sort((a, b) => b - a);
          results.map((items) => {
            vaction.push(items);
          });
          const vactionadddaysfilter = [...new Set(vactionadddays.filter(item => results.includes(item)))];
          vactionadddays = [...new Set(vactionadddays.filter(item => !results.includes(item)))];
          var i;
          for (i = 0; i < vactionadddaysfilter.length; i++) {
            vactionnoadddays.push(vactionadddays.pop());
          }
          this.setState({
            vaction: [...new Set(vaction)],
            vactionadddays: [...new Set(vactionadddays.filter(item => item !== undefined))],
            vactionnoadddays: [...new Set(vactionnoadddays.filter(item => item !== undefined))],
          }, () => {
            this.vactiondays();
          });
          const dates = vaction.sort((a, b) => b - a);

          this.setState({
            vacationEnd: getUtcStringWithoutHours(new Date(
              this.props.bidSessionStartDate[0],
              this.props.bidSessionStartDate[1] - 1,
              dates[0] + 2
            ).getTime())
          });
        }
      }
    }
  }
  handleSave = () => {
    const { vacationSaveBody: data, afterSave } = this.props;
    if (this.state.disabled) {
      data.startDate = getUtcStringWithoutHours(this.vacationWindowStart);
      data.endDate = getUtcStringWithoutHours(this.vacationWindowStart);
      data.isVacationExtended = true;
    } else {
      data.startDate = getUtcStringWithoutHours(this.state.vacationStart);
      data.endDate = getUtcStringWithoutHours(this.state.vacationEnd);
      data.isVacationExtended = true;
    }
    activitySave(this.activityId, data)()
      .then((response) => {
        if (response && response.status === httpStatus.OK) {
          afterSave(calendarLabels.vacationadder.SAVE_MESSAGE, response.data.activity);
        }
      })
      .catch(error => console.log(error));
  }
  render() {
    const actions = [
      <CancelButton
        onClick={this.handleClose}
        className="btn-cancel"
      >{'Cancel'}</CancelButton>,
      <SaveApplyButton
        onClick={this.handleSave}
        className="btn-ok"
      >{'Apply'}</SaveApplyButton>
    ];
    return (
      <Dialog
        title={
          <div className="no-margin">
            <CardTitle
              title={calendarLabels.vacationadder.TITLE}
              subtitle={calendarLabels.vacationadder.SUBTITLE}
              className="vacation-editor-title"
            />
          </div>
        }
        actions={actions}
        modal={false}
        open
        onRequestClose={this.handleClose}
        className="vacation-editor"
        contentClassName="vacation-editor-container"
        actionsContainerClassName="vacation-editor-actions-container"
        bodyClassName="vacation-editor-content"
      >
        <div className="row vacation-editor-dates">
          <div className="small-4 columns original">
            Original dates
            <span>
              {` ${dateToIso(this.originalVacationStart)} — ${dateToIso(this.originalVacationEnd, true)}`}
            </span>

          </div>
          <div className="small-4 small-offset-4 current">
            Current dates
              <span>
                {` ${dateToIso(this.state.vacationStart)} — ${dateToIso(this.state.vacationEnd, true)}`}
              </span>
          </div>
        </div>
        <div className="rowd">
          <div className="vacation" style={{ width: this.state.vactionwidth }}>
            {this.state.totalvacationdays.map(item => <div
              className="vacationadddays"
              style={{ width: this.state.dayswidth, backgroundColor: item.color }}
              onClick={() => this.handleClick(item.value, item.color)}
            >
              {item.value}
            </div>)}
          </div>
        </div>
      </Dialog>
    );
  }
}

VacationAdder.propTypes = {
  handleClose: PropTypes.func.isRequired,
  afterSave: PropTypes.func.isRequired,
  activityId: PropTypes.number.isRequired,
  validatedVacationSlideStartDate: PropTypes.number.isRequired,
  validatedVacationSlideEndDate: PropTypes.number.isRequired,
  originalStartDate: PropTypes.number.isRequired,
  originalEndDate: PropTypes.number.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  bidSessionStartDate: PropTypes.array.isRequired,
  vacationSaveBody: PropTypes.object.isRequired,
};

function VacationAdderWrapper(props) {
  const { labels } = useLanguage();
  return <VacationAdder {...props} labels={labels} />;
}

export default VacationAdderWrapper;
